module.exports = __webpack_public_path__ + "static/media/bin.6b690af3.svg";